module.exports = __webpack_public_path__ + "img/mm-logo-white@2x.8703cbe4.png";